export const stamdataQueryKeys = {
  /**
   * Medlemmets egen stamdata. Nøglen bærer person-id'et, så et fuldmagts-skift ikke læser en anden
   * persons cache. Tager `null`/`undefined`, fordi `UserInfo.id` kan være tomt, før sessionen er
   * kendt — forespørgslen er så slået fra, og nøglen bruges kun til at holde cache-rækkerne adskilt.
   */
  person: (personId?: string | null) => ["stamdata", personId] as const,
};
